module.exports = __webpack_public_path__ + "static/media/twitter_icon.d3cc6c9c.svg";